import { useMemo } from 'react';
import { where, type QueryConstraint } from 'firebase/firestore';
import { useCollection } from './useCollection';
import { hasCouncilFullRead } from '../lib/visibility';
import { tenantWhere, useActiveTenantId } from '../lib/tenant';
import type { InitiativeMessage, UserProfile } from '../types';

/** Emails received at initiative addresses, scoped like initiatives — anyone
 *  in the district reads their district's; admins (and council-wide
 *  members) read all. Grouped by initiativeId in the view. */
export function useVisibleInitiativeMessages(profile: UserProfile) {
  const admin = profile.role === 'admin';
  const unscoped = admin || hasCouncilFullRead(profile);
  const activeTenantId = useActiveTenantId();
  const constraints: QueryConstraint[] = useMemo(
    () => [tenantWhere(), ...(unscoped || !profile.districtId ? [] : [where('districtId', '==', profile.districtId)])],
    [unscoped, profile.districtId, activeTenantId],
  );
  const enabled = unscoped || !!profile.districtId;
  return useCollection<InitiativeMessage>('initiativeMessages', constraints, enabled);
}
